import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/sr-Cyrl/501/',
    component: ComponentCreator('/sr-Cyrl/501/', '9e0'),
    exact: true
  },
  {
    path: '/sr-Cyrl/articles/',
    component: ComponentCreator('/sr-Cyrl/articles/', '94c'),
    exact: true
  },
  {
    path: '/sr-Cyrl/articles/2024/07/09/diskusija-lj-nj-cyrl/',
    component: ComponentCreator('/sr-Cyrl/articles/2024/07/09/diskusija-lj-nj-cyrl/', 'c6a'),
    exact: true
  },
  {
    path: '/sr-Cyrl/articles/2024/07/09/diskusija-lj-nj/',
    component: ComponentCreator('/sr-Cyrl/articles/2024/07/09/diskusija-lj-nj/', '8f3'),
    exact: true
  },
  {
    path: '/sr-Cyrl/articles/archive/',
    component: ComponentCreator('/sr-Cyrl/articles/archive/', '679'),
    exact: true
  },
  {
    path: '/sr-Cyrl/articles/authors/',
    component: ComponentCreator('/sr-Cyrl/articles/authors/', '5af'),
    exact: true
  },
  {
    path: '/sr-Cyrl/search/',
    component: ComponentCreator('/sr-Cyrl/search/', '490'),
    exact: true
  },
  {
    path: '/sr-Cyrl/',
    component: ComponentCreator('/sr-Cyrl/', '45e'),
    exact: true
  },
  {
    path: '/sr-Cyrl/',
    component: ComponentCreator('/sr-Cyrl/', '97d'),
    routes: [
      {
        path: '/sr-Cyrl/',
        component: ComponentCreator('/sr-Cyrl/', '43d'),
        routes: [
          {
            path: '/sr-Cyrl/tags/',
            component: ComponentCreator('/sr-Cyrl/tags/', '791'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/comparative/',
            component: ComponentCreator('/sr-Cyrl/tags/comparative/', '48e'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/grammar/',
            component: ComponentCreator('/sr-Cyrl/tags/grammar/', '62c'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/interslavic/',
            component: ComponentCreator('/sr-Cyrl/tags/interslavic/', 'db2'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/language-learning/',
            component: ComponentCreator('/sr-Cyrl/tags/language-learning/', '845'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/linguistics/',
            component: ComponentCreator('/sr-Cyrl/tags/linguistics/', '5db'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/personal-pronouns/',
            component: ComponentCreator('/sr-Cyrl/tags/personal-pronouns/', '01f'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/pronouns/',
            component: ComponentCreator('/sr-Cyrl/tags/pronouns/', 'ff9'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/slavic-languages/',
            component: ComponentCreator('/sr-Cyrl/tags/slavic-languages/', '212'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/граматика/',
            component: ComponentCreator('/sr-Cyrl/tags/граматика/', '060'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/заменице/',
            component: ComponentCreator('/sr-Cyrl/tags/заменице/', '811'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/међусловенски-језик/',
            component: ComponentCreator('/sr-Cyrl/tags/међусловенски-језик/', 'd69'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/међусловенски/',
            component: ComponentCreator('/sr-Cyrl/tags/међусловенски/', '6bc'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/поређење-језика/',
            component: ComponentCreator('/sr-Cyrl/tags/поређење-језика/', '6a2'),
            exact: true
          },
          {
            path: '/sr-Cyrl/tags/учење-језика/',
            component: ComponentCreator('/sr-Cyrl/tags/учење-језика/', '651'),
            exact: true
          },
          {
            path: '/sr-Cyrl/',
            component: ComponentCreator('/sr-Cyrl/', '67b'),
            routes: [
              {
                path: '/sr-Cyrl/learn/faq/',
                component: ComponentCreator('/sr-Cyrl/learn/faq/', 'da7'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/grammar/',
                component: ComponentCreator('/sr-Cyrl/learn/grammar/', 'ac2'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/grammar/adjectives/',
                component: ComponentCreator('/sr-Cyrl/learn/grammar/adjectives/', '5f2'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/grammar/conjunctions/',
                component: ComponentCreator('/sr-Cyrl/learn/grammar/conjunctions/', 'baa'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/grammar/nouns/',
                component: ComponentCreator('/sr-Cyrl/learn/grammar/nouns/', '0f1'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/grammar/numerals/',
                component: ComponentCreator('/sr-Cyrl/learn/grammar/numerals/', '7fb'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/grammar/prepositions/',
                component: ComponentCreator('/sr-Cyrl/learn/grammar/prepositions/', '1de'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/grammar/pronouns/',
                component: ComponentCreator('/sr-Cyrl/learn/grammar/pronouns/', 'a81'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/grammar/syntax/',
                component: ComponentCreator('/sr-Cyrl/learn/grammar/syntax/', 'e0a'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/grammar/verbs/',
                component: ComponentCreator('/sr-Cyrl/learn/grammar/verbs/', 'd4b'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/introduction/',
                component: ComponentCreator('/sr-Cyrl/learn/introduction/', '194'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/misc/constructed-slavic-languages/',
                component: ComponentCreator('/sr-Cyrl/learn/misc/constructed-slavic-languages/', '54e'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/misc/design-criteria/',
                component: ComponentCreator('/sr-Cyrl/learn/misc/design-criteria/', 'ae2'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/misc/history/',
                component: ComponentCreator('/sr-Cyrl/learn/misc/history/', '3a9'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/misc/language-comparison/',
                component: ComponentCreator('/sr-Cyrl/learn/misc/language-comparison/', 'd46'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/misc/numbers-1-10/',
                component: ComponentCreator('/sr-Cyrl/learn/misc/numbers-1-10/', '634'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/misc/pan-slavic-relay/',
                component: ComponentCreator('/sr-Cyrl/learn/misc/pan-slavic-relay/', '388'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/misc/personal-pronouns/',
                component: ComponentCreator('/sr-Cyrl/learn/misc/personal-pronouns/', 'b46'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/orthography/',
                component: ComponentCreator('/sr-Cyrl/learn/orthography/', '7b6'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/phonology/',
                component: ComponentCreator('/sr-Cyrl/learn/phonology/', 'f08'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/pronunciation/',
                component: ComponentCreator('/sr-Cyrl/learn/pronunciation/', '82e'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/simple-grammar/',
                component: ComponentCreator('/sr-Cyrl/learn/simple-grammar/', '9a1'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/simple-grammar/level-1/',
                component: ComponentCreator('/sr-Cyrl/learn/simple-grammar/level-1/', 'a42'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/simple-grammar/level-2/',
                component: ComponentCreator('/sr-Cyrl/learn/simple-grammar/level-2/', '5c6'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/vocabulary/derivation/',
                component: ComponentCreator('/sr-Cyrl/learn/vocabulary/derivation/', '429'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/vocabulary/flavourisation/',
                component: ComponentCreator('/sr-Cyrl/learn/vocabulary/flavourisation/', '7b6'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/learn/vocabulary/word-formation/',
                component: ComponentCreator('/sr-Cyrl/learn/vocabulary/word-formation/', '9fe'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/sr-Cyrl/resources/',
                component: ComponentCreator('/sr-Cyrl/resources/', '939'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/sr-Cyrl/resources/applets/',
                component: ComponentCreator('/sr-Cyrl/resources/applets/', '49f'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/sr-Cyrl/resources/applets/intelligibility/',
                component: ComponentCreator('/sr-Cyrl/resources/applets/intelligibility/', '7b9'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/sr-Cyrl/resources/applets/transliterator/',
                component: ComponentCreator('/sr-Cyrl/resources/applets/transliterator/', '66b'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/sr-Cyrl/resources/keyboards/',
                component: ComponentCreator('/sr-Cyrl/resources/keyboards/', 'dac'),
                exact: true,
                sidebar: "resourcesSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
